import clsx from 'clsx';
import React from 'react';
import Countdown, { zeroPad } from 'react-countdown';

const renderer = ({ hours, minutes, seconds, milliseconds, completed, textSize }) => {
  return (
    <>
      {zeroPad(minutes)}:{zeroPad(seconds)}:{zeroPad(milliseconds / 10)}
    </>
  );
};

const GameTImer = React.memo((props) => {
  return (
    <p className={clsx('!font-mono font-light text-current', props.textSize)}>
      <Countdown
        date={Date.now() + props.timeLeft * 1000}
        intervalDelay={40}
        precision={2}
        ref={props.gameTimerRef}
        renderer={renderer}
        // className={className}
      />
    </p>
  );
});

export default React.memo(GameTImer);
